module.exports = __webpack_public_path__ + "static/media/R3L3-left.1736e73b.svg";